/**
 * 后台时间显示（spec-platform §0.3、F 节"后台通用"）：一律按 UTC+9 显示并标注，例如 `2026-11-01 14:02 UTC+9`；
 * 录入时间时旁边另显示员工本地时间（浏览器时区）。
 */
import { useI18n } from '@nexora/i18n/react';
import { formatDate, formatTime, type DateValue } from '@nexora/ui';
import { useCallback } from 'react';

/** UTC+9 的 IANA 时区（无夏令时） */
export const ADMIN_TIME_ZONE = 'Asia/Tokyo';

/** `YYYY-MM-DD HH:mm`（UTC+9，不含标注） */
export function adminDateTime(value: DateValue, seconds = false): string {
  return `${formatDate('zh', value, { timeZone: ADMIN_TIME_ZONE })} ${formatTime(value, { timeZone: ADMIN_TIME_ZONE, seconds })}`;
}

/** `YYYY-MM-DD HH:mm` 员工本地时间（浏览器时区） */
export function localDateTime(value: DateValue): string {
  return `${formatDate('zh', value)} ${formatTime(value)}`;
}

/** 带 "UTC+9" 标注的格式化函数。 */
export function useAdminTime(): (value: DateValue, seconds?: boolean) => string {
  const { t } = useI18n();
  return useCallback((value: DateValue, seconds = false) => `${adminDateTime(value, seconds)} ${t('admin.time.utc9')}`, [t]);
}
